import type { FC, SVGProps } from 'react';
import geminiCliPng from './gemini_cli.png';

export const GeminiCliIcon: FC<SVGProps<SVGSVGElement>> = ({
  className,
  style,
}) => (
  <img
    src={geminiCliPng}
    alt="Gemini CLI"
    className={className}
    style={style}
  />
);
